import { render, staticRenderFns } from "./ContratosSigaBase.vue?vue&type=template&id=5d2768cb&"
import script from "./ContratosSigaBase.vue?vue&type=script&lang=ts&"
export * from "./ContratosSigaBase.vue?vue&type=script&lang=ts&"
import style0 from "./ContratosSigaBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports